const csvEscape = (val: string) => {
  const needsQuotes = /[",\n]/.test(val);
  const escaped = val.replace(/"/g, '""');
  return needsQuotes ? `"${escaped}"` : escaped;
};

export const buildCsv = (rows: string[][]) => rows.map(row => row.map(csvEscape).join(',')).join('\n');

export const generateCsvFilename = (filenameBase = 'export') => {
  const ts = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${filenameBase}-${ts.getFullYear()}${pad(ts.getMonth() + 1)}${pad(ts.getDate())}-${pad(ts.getHours())}${pad(ts.getMinutes())}`;
};

export const downloadCsv = (rows: string[][], filenameBase?: string) => {
  const filename = generateCsvFilename(filenameBase || 'export');
  const bom = '\uFEFF';
  const csvContent = bom + buildCsv(rows);
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const buildCsvFromColumns = (
  data: any[],
  columns: Array<{ header: string; value: (item: any) => string }>
) => {
  const headerRow = columns.map(col => col.header);
  const dataRows = data.map(item => columns.map(col => col.value(item)));
  return [headerRow, ...dataRows];
};


